import React from 'react';
import NamedCatalogPage from './NamedCatalogPage';
import { DOSE_FORMS, DOSE_UNITS } from '../utils/fumigation';

export function ExportersPage() {
  return (
    <NamedCatalogPage
      endpoint="exporters/"
      icon="🚢"
      labels={{
        title: 'Exportadores',
        newPlaceholder: 'Nombre del nuevo exportador',
        addButton: 'Agregar exportador',
        empty: 'Aún no hay exportadores.',
        singularArticle: 'el exportador',
        singularDemonstrative: 'este exportador',
        pluralArticle: 'los exportadores',
      }}
    />
  );
}

// "Precio real a 43 lbs": the brand's sales get Precio real = Precio 43 lbs (the Peso caja is kept).
const BRAND_FIELDS = [{
  key: 'real_price_at_43', checkbox: true, label: 'Precio real a 43 lbs',
  title: 'El Precio real de sus ventas se calcula como si la caja pesara 43 lbs (igual al Precio 43 lbs). El peso guardado no cambia.',
}];

export function BrandsPage() {
  return (
    <NamedCatalogPage
      endpoint="brands/"
      extraFields={BRAND_FIELDS}
      icon="🏷️"
      labels={{
        title: 'Marcas',
        newPlaceholder: 'Nombre de la nueva marca',
        addButton: 'Agregar marca',
        empty: 'Aún no hay marcas.',
        singularArticle: 'la marca',
        singularDemonstrative: 'esta marca',
        pluralArticle: 'las marcas',
      }}
    />
  );
}

// The product's usual Tipo and Unidad (optional), filled in by the Fumigación Aérea form.
const PRODUCT_FIELDS = [
  { key: 'form', label: 'Tipo', placeholder: 'Tipo (opcional)', choices: () => DOSE_FORMS },
  {
    key: 'unit', label: 'Unidad', placeholder: 'Unidad (opcional)', dependsOn: 'form',
    choices: (values) => DOSE_UNITS[values.form] || [],
  },
];

export function FumigationProductsPage() {
  return (
    <NamedCatalogPage
      endpoint="fumigation-products/"
      icon="🧪"
      extraFields={PRODUCT_FIELDS}
      labels={{
        title: 'Productos de Fumigación',
        newPlaceholder: 'Nombre del nuevo producto',
        addButton: 'Agregar producto',
        empty: 'Aún no hay productos de fumigación.',
        singularArticle: 'el producto',
        singularDemonstrative: 'este producto',
        pluralArticle: 'los productos de fumigación',
      }}
    />
  );
}

export function FumigationCompaniesPage() {
  return (
    <NamedCatalogPage
      endpoint="fumigation-companies/"
      icon="🛩️"
      labels={{
        title: 'Empresas de Fumigación',
        newPlaceholder: 'Nombre de la nueva empresa',
        addButton: 'Agregar empresa',
        empty: 'Aún no hay empresas de fumigación.',
        singularArticle: 'la empresa',
        singularDemonstrative: 'esta empresa',
        pluralArticle: 'las empresas de fumigación',
      }}
    />
  );
}

// Outside the component so the list keeps its identity between renders (it loads the companies).
const PILOT_FIELDS = [{
  key: 'fumigation_company', label: 'Empresa de fumigación', placeholder: 'Empresa de fumigación',
  optionsEndpoint: 'fumigation-companies/', displayKey: 'fumigation_company_name',
}];

export function FumigationPilotsPage() {
  return (
    <NamedCatalogPage
      endpoint="fumigation-pilots/"
      icon="🧑‍✈️"
      extraFields={PILOT_FIELDS}
      labels={{
        title: 'Pilotos de Fumigación',
        newPlaceholder: 'Nombre del nuevo piloto',
        addButton: 'Agregar piloto',
        empty: 'Aún no hay pilotos de fumigación.',
        singularArticle: 'el piloto',
        singularDemonstrative: 'este piloto',
        pluralArticle: 'los pilotos de fumigación',
      }}
    />
  );
}

export function TransportationsPage() {
  return (
    <NamedCatalogPage
      endpoint="transportations/"
      icon="🚚"
      labels={{
        title: 'Transportes',
        newPlaceholder: 'Nombre del nuevo transporte',
        addButton: 'Agregar transporte',
        empty: 'Aún no hay transportes.',
        singularArticle: 'el transporte',
        singularDemonstrative: 'este transporte',
        pluralArticle: 'los transportes',
      }}
    />
  );
}


export function DestinationsPage() {
  return (
    <NamedCatalogPage
      endpoint="destinations/"
      icon="📍"
      labels={{
        title: 'Destinos',
        newPlaceholder: 'Nombre del nuevo destino',
        addButton: 'Agregar destino',
        empty: 'Aún no hay destinos.',
        singularArticle: 'el destino',
        singularDemonstrative: 'este destino',
        pluralArticle: 'los destinos',
      }}
    />
  );
}

export function DriversPage() {
  return (
    <NamedCatalogPage
      endpoint="drivers/"
      icon="🧑‍✈️"
      extraFields={[
        { key: 'id_number', label: 'Cédula', placeholder: 'Cédula' },
        { key: 'cellphone', label: 'Celular', placeholder: 'Celular' },
        { key: 'license_plate', label: 'Placa', placeholder: 'Placa' },
      ]}
      labels={{
        title: 'Conductores',
        newPlaceholder: 'Nombre del nuevo conductor',
        addButton: 'Agregar conductor',
        empty: 'Aún no hay conductores.',
        singularArticle: 'el conductor',
        singularDemonstrative: 'este conductor',
        pluralArticle: 'los conductores',
      }}
    />
  );
}

export function BoxTypesPage() {
  return (
    <NamedCatalogPage
      endpoint="box-types/"
      icon="📦"
      field="type"
      labels={{
        title: 'Tipos de Caja',
        column: 'Tipo',
        newPlaceholder: 'Nuevo tipo de caja',
        addButton: 'Agregar tipo de caja',
        empty: 'Aún no hay tipos de caja.',
        singularArticle: 'el tipo de caja',
        singularDemonstrative: 'este tipo de caja',
        pluralArticle: 'los tipos de caja',
      }}
    />
  );
}

export function InspectorsPage() {
  return (
    <NamedCatalogPage
      endpoint="inspectors/"
      icon="🔍"
      labels={{
        title: 'Inspectores',
        newPlaceholder: 'Nombre del nuevo inspector',
        addButton: 'Agregar inspector',
        empty: 'Aún no hay inspectores.',
        singularArticle: 'el inspector',
        singularDemonstrative: 'este inspector',
        pluralArticle: 'los inspectores',
      }}
    />
  );
}
